<template>
  <div>
    <div class="onhover-show-div bookmark-flip" :class="bookmarkSearchBox || activeclass ? 'active' : ''">
      <div class="flip-card">
        <div class="flip-card-inner" :class="bookmarkSearchBox ? 'flipped' : ''">
          <div class="front">
            <ul class="droplet-dropdown bookmark-dropdown">
              <li class="gradient-primary bookmark-icon">
                <vue-feather type="star" class="d-block"></vue-feather>
                <h3 class="mb-0">Bookmark</h3>
              </li>
              <li>
                <div class="row">
                  <div class="col-4 text-center" v-for="(items, index) in bookmarkItems" :key="index">
                    <router-link to="/app/fileManager">
                      <vue-feather :type="items.icon"></vue-feather>
                    </router-link> 
                  </div>
                  <div class="col-4 text-center"><router-link to="/widgets/general"><vue-feather
                        type="activity"></vue-feather></router-link></div>
                  <div class="col-4 text-center"><router-link to="/users/profile"><vue-feather
                        type="users"></vue-feather></router-link></div>
                  <div class="col-4 text-center"><router-link to="/form/clipboard"><vue-feather
                        type="clipboard"></vue-feather></router-link></div>
                  <div class="col-4 text-center"><router-link to="/app/todo"><vue-feather
                        type="anchor"></vue-feather></router-link></div>
                  <div class="col-4 text-center"><router-link to="/app/kanban"><vue-feather
                        type="monitor"></vue-feather></router-link></div>
                  <div class="col-4 text-center"><router-link to="/app/fileManager"><vue-feather
                        type="file-text"></vue-feather></router-link></div>
                </div>
              </li>
              <li class="text-center">
                <button class="flip-btn" id="flip-btn" @click="openbookmark">
                  Add New Bookmark
                </button>
              </li>
            </ul>
          </div>
          <div class="back">
            <ul>
              <li>
                <div class="droplet-dropdown bookmark-dropdown flip-back-content">
                  <input type="text" placeholder="search..." v-on:keyup="$store.dispatch('menu/searchTerm', terms)"
                    v-model="terms">
                </div>
                <div class="custom-scrollbar">
                  <ul v-if="searchMenuItems.length > 0">
                    <li v-for="(menuItem, index) in searchMenuItems.slice(0, 8)" :key="index"><vue-feather
                        :type="menuItem.icon"></vue-feather><span @click="removeFix()">
                        <router-link :to="{ path: menuItem.path }" class="realname">{{ menuItem.title }}</router-link>
                      </span>
                      <a href="JavaScript:void(0);" @click="addToBookmark(menuItem)">
                        <span><i class="fa fa-star-o f-18 bookmark-search f-right"
                            :class="menuItem.bookmark ? 'text-warning' : ''"></i></span></a>
                    </li>
                  </ul>
                  <div class="bookmark-search custom-scrollbar" :class="searchMenuItems.length > 0 ? 'Typeahead-menu is-open'
                    : 'Typeahead-menu '" v-if="searchMenuItems.length > 0">
                    <div class="ProfileCard u-cf" v-for="(menuItem, index) in searchMenuItems.slice(0, 8)" :key="index">
                      <div class="ProfileCard-avatar header-search">

                      </div>
                      <div class="ProfileCard-details">
                        <div class="ProfileCard-realName">
                          <span @click="removeFix()">
                            <router-link :to="{ path: menuItem.path }" class="realname">{{ menuItem.title }}</router-link>
                          </span>
                          <a href="JavaScript:void(0);" @click="addToBookmark(menuItem)">
                            <span><i class="fa fa-star-o f-18 bookmark-search f-right"
                                :class="menuItem.bookmark ? 'text-warning' : ''"></i></span></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div :class="bookmarkSearchResultEmpty ? 'Typeahead-menu is-open' : 'Typeahead-menu'">
                  <div class="tt-dataset tt-dataset-0">
                    <div class="EmptyMessage">
                      Your search turned up 0 results. Opps There are no result
                      found.
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <a href="javascript:void(0)" class="d-block flip-back f-w-700" id="flip-back" @click="openbookmark">
                  Back
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>

import { mapState } from 'vuex';

export default {
  props: ['activeclass'],
  data() {
    return {
      terms: '',
      bookmarkSearchBox: false,
      bookmarkSearchResult: false,
      bookmarkSearchResultEmpty: false,
      bookmarkItems: [],
    };
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.data,
      searchMenuItems: (state) => state.menu.searchData,
    }),
  },
  watch: {
    searchMenuItems: function () {
      this.terms ? this.addFix() : this.removeFix();
      if (!this.searchMenuItems.length) this.bookmarkSearchResultEmpty = true;
      else this.bookmarkSearchResultEmpty = false;

    },
  },
  mounted() {
    this.menuItems.filter((items) => {
      if (items.bookmark) {
        this.bookmarkItems.push(items);
      }
    });
  },
  methods: {
    openbookmark() {
      this.bookmarkSearchBox = !this.bookmarkSearchBox;
      if (!this.bookmarkSearchBox) this.removeFix();
    },
    searchTerm: function () {
      this.addFix();
      this.$store.dispatch('menu/searchTerm', this.terms);
    },
    addFix() {
      this.bookmarkSearchResult = true;
    },
    removeFix() {
      this.bookmarkSearchResult = false;
      this.text = '';
    },
    addToBookmark(items) {
      const index = this.bookmarkItems.indexOf(items);
      if (index === -1 && !items.bookmark) {
        items.bookmark = true;
        this.bookmarkItems.push(items);
        this.text = '';
      } else {
        this.bookmarkItems.splice(index, 1);
        items.bookmark = false;
      }
    },
  },
};

</script>